// extracted by mini-css-extract-plugin
module.exports = {"withBackground":"_17lA_Vj"};